import * as React from 'react';
import { observer } from 'mobx-react';
import { TxpObject, TxpDatapoint } from 'txp-data';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import Txp from './Txp';
import OwaTxpStyle from '../store/viewSchema/OwaTxpStyle';
import { createCalendarFormStyle } from '../utils/view/createTxpStyle';
import createCalendarReadFormTxpConfiguration from '../utils/view/createCalendarReadFormTxpConfiguration';
import getTxpLocation from '../utils/view/getTxpLocation';
import createTxpStrings from '../utils/view/createTxpStrings';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import populateCardViewedDatapoint from 'owa-txp/lib/utils/telemetry/populateCardViewedDatapoint';
import getOriginFromTxpObject from 'owa-txp/lib/utils/view/getOriginFromTxpObject';

const styles = require('./Txp.scss');

export interface TxpCalendarFormWrapperProps extends React.HTMLProps<HTMLDivElement> {
    entityNamesMap: number;
    txpObject: TxpObject;
    colorScheme: ColorScheme;
    txpLocation: EnhancedLocation;
    isInvoiceSupported?: boolean;
    isServiceReservationSupported?: boolean;

    // Callbacks hooks for logging data points
    datapointLogger?: (txpDatapoint: TxpDatapoint, datapointName: string) => void;
}

@observer
export default class TxpCalendarFormWrapper extends React.Component<TxpCalendarFormWrapperProps> {
    private txpConfiguration: TxpConfiguration;
    private txpStyle: OwaTxpStyle;

    constructor(props: TxpCalendarFormWrapperProps) {
        super(props);
        const {
            entityNamesMap,
            isInvoiceSupported,
            isServiceReservationSupported,
            txpLocation,
            colorScheme,
        } = this.props;

        this.txpConfiguration = createCalendarReadFormTxpConfiguration(
            isInvoiceSupported,
            isServiceReservationSupported,
            entityNamesMap,
            txpLocation,
            colorScheme,
            styles
        );

        this.onCardViewed();
    }

    public UNSAFE_componentWillReceiveProps(newProps: TxpCalendarFormWrapperProps) {
        if (newProps.txpLocation != this.props.txpLocation) {
            this.txpConfiguration.getLocationControl = (showFullAddress: boolean) =>
                getTxpLocation(
                    newProps.txpLocation,
                    showFullAddress,
                    this.txpConfiguration.txpImages,
                    this.txpStyle
                );
        }
    }

    render() {
        const { txpObject, colorScheme } = this.props;
        this.txpStyle = createCalendarFormStyle(colorScheme, styles);
        const txpStrings = createTxpStrings();

        if (txpObject) {
            return (
                <Txp
                    txpObject={txpObject}
                    txpStrings={txpStrings}
                    txpStyle={this.txpStyle}
                    txpConfiguration={this.txpConfiguration}
                    className={styles.calendarFormWrapper}
                />
            );
        } else {
            return null;
        }
    }

    private onCardViewed = () => {
        const { datapointLogger, entityNamesMap, txpObject } = this.props;
        populateCardViewedDatapoint(
            datapointLogger,
            getOriginFromTxpObject(txpObject),
            entityNamesMap
        );
    };
}
